// 기초 유틸
export const isString = <T = unknown>(str: string | T): str is string =>
  typeof str === 'string';
export const isObject = (val: unknown) => typeof val === 'object';
export const isFunction = (val: unknown) => typeof val === 'function';
export const isBoolean = (val: unknown) => typeof val === 'boolean';
export const isUndefined = (val: unknown) => typeof val === 'undefined';
export const isDefined = (val: unknown) => typeof val !== 'undefined';
export const isNumber = (val: unknown) => typeof val === 'number';
export const isArray = (val: unknown) => Array.isArray(val);
export const isDate = (val: unknown) =>
  Object.prototype.toString.call(val) === '[object Date]';
export const isEmpty = (val: unknown) =>
  val == null || !(Object.keys(val) || val).length;
export const isEmptyArray = (val: unknown[]) =>
  Array.isArray(val) && val.length === 0;
export const isEmptyObj = (val: object): boolean =>
  Object(val) === val && Object.keys(val).length === 0;
export const parseIntOrDefault = (val: string, defaultVal: unknown) => {
  const num = parseInt(val, 10);
  return Number.isNaN(num) ? defaultVal : num;
};
export const validLen = (val: string | unknown[], cond: boolean) =>
  cond !== false ? `${val.toString()}`.trim().length : val.length;

// typeof window
export const IS_BROWSER = typeof window !== 'undefined';
